import BaseModel from 'src/model/base.model';
import CartItemModel from './cartItem.model';
import LocationModel from './location.model';

export class CartModel extends BaseModel {
  public delivery: 'Shipping' | 'Pick-Up' | 'Delivery';
  public deliveryLocation: LocationModel;
  public deliveryLocationCode: string;
  public suppliedFromCode: string;
  public itemCount: number;
  public items: {
    [key: string]: CartItemModel;
  };
  public subTotal: string;
}

export default CartModel;
